import { useState, useEffect, useRef } from "react";
import TimeExpired from "../assets/timeExpired.svg";
import RemainingTime from "../assets/clock.svg";
const pad = (n) => String(n).padStart(1, "0");
export function getCountdown(isoDateString) {
  const target = new Date(isoDateString);
  const now = new Date();
  const diff = target - now;

  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
  }

  const totalSeconds = Math.floor(diff / 1000);

  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    expired: false,
  };
}
export default function CountdownTimer({ targetDate }) {
  // targetDate = new Date().toISOString();
  const [countdown, setCountdown] = useState(() => getCountdown(targetDate));
  const intervalRef = useRef(null);

  useEffect(() => {
    // Update immediately when targetDate changes
    setCountdown(getCountdown(targetDate));

    intervalRef.current = setInterval(() => {
      setCountdown(getCountdown(targetDate));
    }, 60_000); // update every minute

    return () => clearInterval(intervalRef.current);
  }, [targetDate]);

  if (countdown.expired) {
    return (
      <span className="text-[#E83D3D] text-xs flex items-center gap-[10px]">
        {" "}
        00 : 00 <img src={TimeExpired} alt="clock-icon" />
      </span>
    );
  }

  return (
    <div className="flex items-center gap-[10px]">
      <div className="text-xs flex items-center gap-0.5">
        {countdown.days > 0 && <span>{pad(countdown.days)}d</span>}
        {countdown.hours > 0 && <span>{pad(countdown.hours)}h</span>}
        {countdown.minutes > 0 && <span>{pad(countdown.minutes)}m</span>}
      </div>
      <img src={RemainingTime} alt="clock-icon" />
    </div>
  );
}
